import type { PageContext } from '@zto/zpage'

export function communityDialog(isEdit: boolean) {
  return {
    width: 760,
    labelWidth: 120,
    itemSpan: 24,
    title: isEdit ? '编辑小区' : '添加小区',
    onShow: async ({ app, data }: PageContext) => {
      if(!isEdit) return
      const id = data?.id
      const detail = await app.request({
        api: '/sys/admin/api/region/community/detail',
        method: 'POST',
        params: { id }
      })
      const { provinceCode, province, cityCode, city, districtCode, district, communityPhoto, ...other } = detail || {}
      return {
        payload: {
          ...other,
          pcd: [{ provinceCode, province, cityCode, city, districtCode, district }],
          photoUrls: communityPhoto ? [communityPhoto] : []
        }
      }
    },
    formItems: [
      {
        type: 'text',
        prop: 'communityCode',
        label: '小区编码',
        visibleOn: `${isEdit}`
      },
      {
        type: 'input',
        prop: 'communityName',
        label: '小区名称',
        required: true,
        trim: true,
        showWordLimit: true,
        maxlength: 50
      },
      {
        label: '所在地区',
        type: 'area-pro',
        prop: 'pcd',
        keyConfig: {
          provinceCode: 'provinceCode',
          province: 'province',
          cityCode: 'cityCode',
          city: 'city',
          districtCode: 'districtCode',
          district: 'district'
        },
        filterable: true,
        required: true
      },
      {
        type: 'input',
        prop: 'addressDetail',
        label: '详细地址',
        required: true,
        trim: true,
        showWordLimit: true,
        maxlength: 100
      },
      {
        type: 'input',
        prop: 'buildYear',
        label: '所属年代',
        trim: true,
        maxlength: 10,
        showWordLimit: true,
        placeholder: '如：2000年'
      },
      {
        type: 'input-number',
        prop: 'totalBuildingCount',
        label: '总楼栋(栋)',
        min: 0,
        max: 500,
        precision: 0,
        span: 8
      },
      {
        type: 'input-number',
        prop: 'totalUnitCount',
        label: '总单元数(单元)',
        min: 0,
        max: 1000,
        precision: 0,
        span: 8
      },
      {
        type: 'input-number',
        prop: 'totalHouseholdCount',
        label: '总户数(户)',
        min: 0,
        max: 10000,
        precision: 0,
        span: 8
      },
      {
        label: '小区照片',
        type: 'upload',
        prop: 'photoUrls',
        multiple: true,
        accept: '.jpeg,.jpg,.png,.gif',
        uploadAttrs: {
          dialogTitle: '上传文件',
          tip: '支持jpg、png、jpeg、gif格式，大小2M以内',
          sizeLimit: 2
        },
        // listAttrs: { enhance: true }, // 增强属性不支持gif
        listType: 'image', // 图片格式
        countLimit: 1,
        autoHeight: true,
      },
      {
        type: 'input',
        prop: 'contactName',
        label: '联系人姓名',
        required: true,
        trim: true,
        maxlength: 10,
        span: 12
      },
      {
        type: 'input',
        prop: 'contactMobile',
        label: '联系人手机号',
        required: true,
        trim: true,
        maxlength: 11,
        span: 12,
        rules: [{ pattern: /^1[3-9][0-9]\d{8}$/, message: '请填写正确的手机号码' }]
      }
    ],
    beforeSubmit: async ({ data }: PageContext, model: any, options: any) => {
      const { pcd, photoUrls, ...other} = data || {}
      return {
        ...other,
        ...(pcd?.[0] || {}),
        communityPhoto: photoUrls?.[0]
      }
    },
    actions: {
      close: {},
      submit: { label: '确定' }
    }
  }
}
